import * as React from 'react';

const WhatsAppIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15}>
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M12.685 2.123a7.49 7.49 0 0 0-9.72-.625 7.182 7.182 0 0 0-1.915 9.383L0 14.646l3.93-1.02a7.49 7.49 0 0 0 3.532.885 7.396 7.396 0 0 0 6.82-4.479 7.172 7.172 0 0 0-1.583-7.91h-.014ZM7.456 13.292a6.212 6.212 0 0 1-3.137-.84l-.216-.15-2.325.616.621-2.226-.154-.225a5.96 5.96 0 0 1 .736-7.362 6.225 6.225 0 0 1 7.439-1.14 6 6 0 0 1 2.982 6.792 6.128 6.128 0 0 1-5.948 4.536l.003-.001Zm3.369-4.518c-.185-.092-1.093-.53-1.264-.591-.171-.062-.285-.09-.413.09s-.48.59-.571.709c-.091.117-.217.137-.399.045a5.08 5.08 0 0 1-1.486-.891 5.5 5.5 0 0 1-1.05-1.256c-.109-.182 0-.28.08-.375.08-.094.185-.21.285-.316.074-.091.135-.192.182-.3a.334.334 0 0 0 0-.32c-.046-.09-.416-.984-.57-1.345-.155-.362-.32-.3-.434-.315a3.447 3.447 0 0 0-.345-.02.687.687 0 0 0-.493.224A2.02 2.02 0 0 0 3.7 5.63c.06.686.323 1.339.756 1.875a8.196 8.196 0 0 0 3.154 2.743c.343.148.693.275 1.05.381.378.114.776.14 1.164.075a1.908 1.908 0 0 0 1.239-.863c.12-.27.156-.571.105-.863-.042-.075-.16-.118-.345-.208l.002.004Z"
      clipRule="evenodd"
    />
  </svg>
);

export default WhatsAppIcon;
